export default __webpack_public_path__ + "static/media/crested.51b838a3.jpg";